import { Caddy } from "./caddy.model";
import { Language } from "./language.model";

export class customSettings {
    distance = "meters";
    general = '';
    onCourse = '';
    onCourseMode = '';
    onCourseAudio = '';
}
export class User {
    name = "";
    email = "";
    role = "";
    isEmailVerified = false;
    isProAccount = false;
    language: Language | null = null;
    caddy: Caddy = new Caddy();
    image = "";
    isEmailNotificationEnabled = false;
    isPushNotificationEnabled = false;
    isUsageAndTrackingEnabled = false;
    customSettings: any;
    imageUrl = "";
    phone = "";
}